import * as React from 'react';

import { createIcon } from '../Icon';
export const VolumeIcon = createIcon(
  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />,
  'VolumeIcon'
);
